<div class="no-internet-wrap">
    <div class="supported-img mb-4">
        <img class="img-fluid" src="/assets/images/under-maintenance-img.png" alt="no-internet-img">
    </div>
    <div class="title">We're Under Maintenance</div>
    <div class="sub-title">We are currently performing scheduled maintenance. <br>We will back shortly. Thank you for your patience.</div>
    <div class="try-again-btn">
        <button type="button" class="btn btn-primary fw-semibold rounded-3 f-14 lh-14 w-100 h-38" [disabled]="loading"
            (click)="onTryAgain()">Try Again</button>
    </div>
</div>